module.exports = __webpack_public_path__ + "static/media/angle-double-left.e49c345c.svg";